import React, { useEffect } from "react";
import {
  Container,
  Row,
  Col,
  InputGroup,
  Button,
  Card,
  CardHeader,
  CardBody,
  Label,
  CardFooter,
} from "reactstrap";
import CustomInput from "../../custom/CustomInput";
import CustomSelect from "../../custom/CustomSelect";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as actions from "../../redux/creators";
import * as Yup from "yup";
import { useSelector, useDispatch, batch } from "react-redux";
import { useNavigate } from "react-router-dom";
import CircularIndeterminate from "../loader/CircularIndeterminate";

const RegisterTeacher = () => {
  const dispatch = useDispatch();
  const { isPostLoading, teachers } = useSelector((state) => state.coursereg);
  console.log("first", isPostLoading, teachers);

  useEffect(() => {
    dispatch(actions.teachersGetData());
  }, []);

  const handleSubmit = (values, { setSubmitting, resetForm }) => {
    const teachers = {
      name: values.name,
      email: values.email,
      phone: values.phone,
      mobile: values.mobile,
      age: values.age,
      dob: values.dob,
      gender: values.gender,
      marital_status: values.marital_status,
      address: values.address,
      music_details: values.music_details,
      previous_details: values.previous_details,
      reason_for_joining: values.reason_for_joining,
      experience_years: values.experience_years,
    };
    dispatch(actions.postTeacher(teachers, setSubmitting, resetForm));
    setSubmitting(true);
    return;
  };
  return (
    <React.Fragment>
      <Container>
        <div className="bg-white">
          <Row>
            <h5 className="text-center p-3">
              Please fill the form to register for batches.
            </h5>
          </Row>
          <Card>
            <CardBody>
              <Formik
                initialValues={{
                  name: "",
                  email: "",
                  phone: "",
                  mobile: "",
                  age: "",
                  dob: "",
                  gender: "",
                  marital_status: "",
                  address: "",
                  music_details: "",
                  previous_details: "",
                  reason_for_joining: "",
                  experience_years: "",
                }}
                onSubmit={handleSubmit}
                validationSchema={Yup.object().shape({
                  email: Yup.string()
                    .required("Enter Your Email")
                    .email("Invalid Email address"),
                  name: Yup.string().required("required"),
                  phone: Yup.string().required("required"),
                })}
              >
                {(formProps) => (
                  <Form className="mt-3">
                    <Row className="form-group">
                      <Col md={6} className="mt-3">
                        <Label htmlFor="name" className="label">
                          Your Full Name:
                        </Label>
                        <InputGroup>
                          <Field
                            component={CustomInput}
                            type="text"
                            name="name"
                            id="name"
                            placeholder="Enter Your Name"
                            className={
                              "form-control" +
                              (formProps.errors.name && formProps.touched.name
                                ? " is-invalid"
                                : "")
                            }
                          />
                          <ErrorMessage
                            name="name"
                            component="div"
                            className="invalid-feedback"
                          />
                        </InputGroup>
                      </Col>
                      <Col md={6} className="mt-3">
                        <Label htmlFor="email" className="label">
                          Your Email:
                        </Label>
                        <InputGroup>
                          <Field
                            component={CustomInput}
                            type="text"
                            name="email"
                            id="email"
                            placeholder="Enter Your Email"
                            className={
                              "form-control" +
                              (formProps.errors.email && formProps.touched.email
                                ? " is-invalid"
                                : "")
                            }
                          />
                          <ErrorMessage
                            name="email"
                            component="div"
                            className="invalid-feedback"
                          />
                        </InputGroup>
                      </Col>
                    </Row>
                    <Row className="form-group">
                      <Col md={6} className="mt-3">
                        <Label htmlFor="phone" className="label">
                          Your Phone:
                        </Label>
                        <InputGroup>
                          <Field
                            component={CustomInput}
                            type="text"
                            name="phone"
                            id="phone"
                            placeholder="Enter Your Phone"
                            className={
                              "form-control" +
                              (formProps.errors.phone && formProps.touched.phone
                                ? " is-invalid"
                                : "")
                            }
                          />
                          <ErrorMessage
                            name="phone"
                            component="div"
                            className="invalid-feedback"
                          />
                        </InputGroup>
                      </Col>
                      <Col md={6} className="mt-3">
                        <Label htmlFor="mobile" className="label">
                          Your Mobile:
                        </Label>
                        <InputGroup>
                          <Field
                            component={CustomInput}
                            type="text"
                            name="mobile"
                            id="mobile"
                            placeholder="Enter Your Mobile"
                            className={
                              "form-control" +
                              (formProps.errors.mobile &&
                              formProps.touched.mobile
                                ? " is-invalid"
                                : "")
                            }
                          />
                          <ErrorMessage
                            name="mobile"
                            component="div"
                            className="invalid-feedback"
                          />
                        </InputGroup>
                      </Col>
                    </Row>
                    <Row className="form-group">
                      <Col md={6} className="mt-3">
                        <Label htmlFor="age" className="label">
                          Your Age:
                        </Label>
                        <InputGroup>
                          <Field
                            component={CustomInput}
                            type="text"
                            name="age"
                            id="age"
                            placeholder="Your Age in Years"
                            className={
                              "form-control" +
                              (formProps.errors.age && formProps.touched.age
                                ? " is-invalid"
                                : "")
                            }
                          />
                          <ErrorMessage
                            name="age"
                            component="div"
                            className="invalid-feedback"
                          />
                        </InputGroup>
                      </Col>
                      <Col md={6} className="mt-3">
                        <Label htmlFor="dob" className="label">
                          Enter Your DOB :
                        </Label>
                        <InputGroup>
                          <Field
                            component={CustomInput}
                            type="date"
                            name="dob"
                            id="dob"
                            placeholder="Enter Your DOB"
                            className={
                              "form-control" +
                              (formProps.errors.dob && formProps.touched.dob
                                ? " is-invalid"
                                : "")
                            }
                          />
                          <ErrorMessage
                            name="dob"
                            component="div"
                            className="invalid-feedback"
                          />
                        </InputGroup>
                      </Col>
                    </Row>
                    <Row className="form-group">
                      <Col md={6} className="mt-3">
                        <Label htmlFor="gender" className="label">
                          Select Gender:
                        </Label>
                        <InputGroup>
                          <Field
                            component={CustomSelect}
                            type="select"
                            name="gender"
                            id="gender"
                            className={
                              "form-control" +
                              (formProps.errors.gender &&
                              formProps.touched.gender
                                ? " is-invalid"
                                : "")
                            }
                          >
                            <option value={""}>Select Gender</option>
                            <option value={"Male"}>Male</option>
                            <option value={"Female"}>Female</option>
                          </Field>
                          <ErrorMessage
                            name="gender"
                            component="div"
                            className="invalid-feedback"
                          />
                        </InputGroup>
                      </Col>
                      <Col md={6} className="mt-3">
                        <Label htmlFor="marital_status" className="label">
                          Select Marital Status:
                        </Label>
                        <InputGroup>
                          <Field
                            component={CustomSelect}
                            type="select"
                            name="marital_status"
                            id="marital_status"
                            className={
                              "form-control" +
                              (formProps.errors.marital_status &&
                              formProps.touched.marital_status
                                ? " is-invalid"
                                : "")
                            }
                          >
                            <option value={""}>Select Marital Status</option>
                            <option value={"Married"}>Married</option>
                            <option value={"Unmarried"}>Unmarried</option>
                          </Field>
                          <ErrorMessage
                            name="marital_status"
                            component="div"
                            className="invalid-feedback"
                          />
                        </InputGroup>
                      </Col>
                    </Row>
                    <Row className="form-group">
                      <Col md={12} className="mt-3">
                        <Label htmlFor="address" className="label">
                          Your Address / Current Location:
                        </Label>
                        <InputGroup>
                          <Field
                            component={CustomInput}
                            type="textarea"
                            name="address"
                            id="address"
                            placeholder="Your Address / Current Location"
                            className={
                              "form-control" +
                              (formProps.errors.address &&
                              formProps.touched.address
                                ? " is-invalid"
                                : "")
                            }
                          />
                          <ErrorMessage
                            name="address"
                            component="div"
                            className="invalid-feedback"
                          />
                        </InputGroup>
                      </Col>
                    </Row>
                    <Row className="form-group">
                      <Col md={12} className="mt-3">
                        <Label htmlFor="music_details" className="label">
                          Your Details of Music Qualification:
                        </Label>
                        <InputGroup>
                          <Field
                            component={CustomInput}
                            type="textarea"
                            name="music_details"
                            id="music_details"
                            placeholder="Your Details of Music Qualification"
                            className={
                              "form-control" +
                              (formProps.errors.music_details &&
                              formProps.touched.music_details
                                ? " is-invalid"
                                : "")
                            }
                          />
                          <ErrorMessage
                            name="music_details"
                            component="div"
                            className="invalid-feedback"
                          />
                        </InputGroup>
                      </Col>
                    </Row>
                    <Row className="form-group">
                      <Col md={12} className="mt-3">
                        <Label htmlFor="experience_years" className="label">
                          Your Total Music Teaching Experience in Years:
                        </Label>
                        <InputGroup>
                          <Field
                            component={CustomInput}
                            type="text"
                            name="experience_years"
                            id="experience_years"
                            placeholder="Your Total Music Teaching Experience in Years"
                            className={
                              "form-control" +
                              (formProps.errors.experience_years &&
                              formProps.touched.experience_years
                                ? " is-invalid"
                                : "")
                            }
                          />
                          <ErrorMessage
                            name="experience_years"
                            component="div"
                            className="invalid-feedback"
                          />
                        </InputGroup>
                      </Col>
                    </Row>
                    <Row className="form-group">
                      <Col md={12} className="mt-3">
                        <Label htmlFor="previous_details" className="label">
                          Detail Of School / Institutes Worked With Previously:
                        </Label>
                        <InputGroup>
                          <Field
                            component={CustomInput}
                            type="textarea"
                            name="previous_details"
                            id="previous_details"
                            placeholder="Detail Of School / Institutes Worked With Previously"
                            className={
                              "form-control" +
                              (formProps.errors.previous_details &&
                              formProps.touched.previous_details
                                ? " is-invalid"
                                : "")
                            }
                          />
                          <ErrorMessage
                            name="previous_details"
                            component="div"
                            className="invalid-feedback"
                          />
                        </InputGroup>
                      </Col>
                    </Row>
                    <Row className="form-group">
                      <Col md={12} className="mt-3">
                        <Label htmlFor="reason_for_joining" className="label">
                          Reason for Joining Ajivasan (max 1000 words):
                        </Label>
                        <InputGroup>
                          <Field
                            component={CustomInput}
                            type="textarea"
                            name="reason_for_joining"
                            id="reason_for_joining"
                            placeholder="Reason for Joining Ajivasan (max 1000 words)"
                            className={
                              "form-control" +
                              (formProps.errors.reason_for_joining &&
                              formProps.touched.reason_for_joining
                                ? " is-invalid"
                                : "")
                            }
                          />
                          <ErrorMessage
                            name="reason_for_joining"
                            component="div"
                            className="invalid-feedback"
                          />
                        </InputGroup>
                      </Col>
                    </Row>

                    <div className="mt-3 mb-3 row">
                      <div className="col-12">
                        <Button
                          type="submit"
                          className="register-btn"
                          size="md"
                          block
                        >
                          {isPostLoading ? (
                            <CircularIndeterminate />
                          ) : (
                            "REGISTER"
                          )}
                        </Button>
                      </div>
                    </div>
                  </Form>
                )}
              </Formik>
            </CardBody>
          </Card>
        </div>
      </Container>
    </React.Fragment>
  );
};

export default RegisterTeacher;
